import {
    normalize_assignment_effective_from
} from "@/components/Settings/settings_utils";

export default {
    async edit_tariff(row) {
        if (this.should_open_tariff_assignment(row)) {
            this.open_tariff_assignment(row);
            return;
        }

        await this.unassign_tariff(row);
    },

    should_open_tariff_assignment(row) {
        return !row.has_assignment || !row.raw;
    },

    open_tariff_assignment(row) {
        this.selected_assignment_id = null;
        this.is_property_locked = true;
        this.form_error = "";
        this.new_tariff = this.create_tariff_form(row.property_id);
        this.show_add_tariff_modal = true;
    },

    create_tariff_form(property_id = "") {
        return ({
            property_id: property_id || "",
            municipality_id: "",
            municipality_search: "",
            tariff_book_id: "",
            tariff_id: "",
            effective_from: "",
            effective_to: "",
            is_active: true
        });
    },

    async unassign_tariff(row) {
        this.is_saving = true;
        this.load_error = "";

        try {
            await this.send_tariff_unassignment(row);
            await this.load_tariff_settings_data();
        } catch (error) {
            this.set_load_error(error.message || "Unable to unassign tariff.");
        } finally {
            this.is_saving = false;
        }
    },

    async send_tariff_unassignment(row) {
        const payload = {
            assignment_id: Number(row.id),
            is_active: false
        };
        await this.fetch_assignment_json(
            this.get_assignment_toggle_url(),
            {
                method: "POST",
                headers: this.get_auth_headers(true),
                body: JSON.stringify(payload)
            }
        );
    },

    async add_tariff() {
        if (this.is_tariff_form_incomplete()) {
            this.form_error = "Property, tariff book, and tariff are required.";
            return;
        }

        this.is_saving = true;
        this.form_error = "";

        try {
            await this.save_new_tariff_assignment();
        } catch (error) {
            this.form_error = error.message || "Unable to save tariff assignment.";
        } finally {
            this.is_saving = false;
        }
    },

    is_tariff_form_incomplete() {
        return !this.new_tariff.property_id
            || !this.new_tariff.tariff_book_id
            || !this.new_tariff.tariff_id;
    },

    async save_new_tariff_assignment() {
        const context = this.build_tariff_assignment_context();
        await this.update_tariff_municipality(context.municipality);
        await this.save_assignment(
            context.payload,
            this.get_assignment_create_url(),
            context.reusable_assignment
        );
        this.apply_effective_from(context.effective_from);
        await this.load_tariff_settings_data();
        this.close_add_tariff_modal();
    },

    build_tariff_assignment_context() {
        const reusable_assignment = this.find_inactive_assignment(
            this.new_tariff.property_id,
            this.new_tariff.tariff_id
        );
        const requested_date = this.get_requested_effective_from();
        const next_date = this.get_next_available_assignment_effective_from(
            this.new_tariff.property_id,
            requested_date
        );
        const effective_from = this.resolve_effective_from(reusable_assignment, next_date);

        return ({
            reusable_assignment,
            effective_from,
            payload: this.build_tariff_assignment_payload(
                reusable_assignment,
                effective_from
            ),
            municipality: this.get_tariff_municipality_context()
        });
    },

    get_requested_effective_from() {
        return this.new_tariff.effective_from
            || new Date().toISOString().slice(0, 10);
    },

    resolve_effective_from(reusable_assignment, next_date) {
        return normalize_assignment_effective_from(reusable_assignment) || next_date;
    },

    build_tariff_assignment_payload(reusable_assignment, effective_from) {
        return ({
            property_id: Number(this.new_tariff.property_id),
            tariff_id: Number(this.new_tariff.tariff_id),
            effective_from,
            effective_to: this.get_effective_to(reusable_assignment),
            is_active: Boolean(this.new_tariff.is_active)
        });
    },

    get_effective_to(reusable_assignment) {
        return this.new_tariff.effective_to
            || reusable_assignment?.effective_to
            || null;
    },

    get_tariff_municipality_context() {
        const municipality_id = Number(this.new_tariff.municipality_id);
        const tariff = this.get_selected_tariff();
        return ({
            municipality_id,
            tariff,
            should_update: this.should_update_tariff_municipality(
                municipality_id,
                tariff
            )
        });
    },

    get_selected_tariff() {
        return this.tariffs.find(
            (tariff) => Number(tariff.id) === Number(this.new_tariff.tariff_id)
        ) || null;
    },

    should_update_tariff_municipality(municipality_id, tariff) {
        if (!Number.isInteger(municipality_id)) return false;
        if (municipality_id <= 0) return false;
        if (!tariff) return false;
        return !this.tariff_has_municipality(tariff);
    },

    tariff_has_municipality(tariff) {
        const municipality_id = Number(tariff.municipality_id);
        return Number.isInteger(municipality_id) && municipality_id > 0;
    },

    async update_tariff_municipality(context) {
        if (!context.should_update) return;

        await this.fetch_settings_json(
            this.get_tariff_update_url(this.new_tariff.tariff_id),
            {
                method: "POST",
                headers: this.get_auth_headers(true),
                body: JSON.stringify({
                    municipality_id: context.municipality_id
                })
            }
        );
    },

    apply_effective_from(effective_from) {
        if (effective_from === this.new_tariff.effective_from) return;
        this.new_tariff = {
            ...this.new_tariff,
            effective_from
        };
    }
};
